var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.125,
    cy: 38.125,
    r: 38.125,
    fill: "#003777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 27.7085V26.6669C25.3843 26.667 25.151 26.7505 24.9649 26.9032C24.7788 27.0559 24.6513 27.2683 24.6042 27.5044L25.625 27.7085ZM50.625 27.7085L51.6458 27.5044C51.5987 27.2683 51.4712 27.0559 51.2851 26.9032C51.099 26.7505 50.8657 26.667 50.625 26.6669V27.7085ZM52.7083 38.1252V39.1669C52.8624 39.1668 53.0145 39.1325 53.1537 39.0666C53.2929 39.0006 53.4158 38.9046 53.5134 38.7854C53.6111 38.6663 53.6811 38.5269 53.7184 38.3775C53.7557 38.228 53.7594 38.0721 53.7292 37.921L52.7083 38.1252ZM23.5417 38.1252L22.5208 37.921C22.4906 38.0721 22.4943 38.228 22.5316 38.3775C22.5689 38.5269 22.6389 38.6663 22.7366 38.7854C22.8342 38.9046 22.9571 39.0006 23.0963 39.0666C23.2355 39.1325 23.3876 39.1668 23.5417 39.1669V38.1252ZM29.7917 44.3752H28.75V45.4169H29.7917V44.3752ZM46.4583 44.3752V45.4169H47.5V44.3752H46.4583ZM22.5 53.7502H53.75V51.6669H22.5V53.7502ZM24.5833 38.1252V52.7085H26.6667V38.1252H24.5833ZM49.5833 38.1252V52.7085H51.6667V38.1252H49.5833ZM25.625 28.7502H50.625V26.6669H25.625V28.7502ZM49.6042 27.9127L51.6875 38.3294L53.7292 37.921L51.6458 27.5044L49.6042 27.9127ZM52.7083 37.0835H23.5417V39.1669H52.7083V37.0835ZM24.5625 38.3294L26.6458 27.9127L24.6042 27.5044L22.5208 37.921L24.5625 38.3294ZM24.5833 24.5835H51.6667V22.5002H24.5833V24.5835ZM28.75 38.1252V44.3752H30.8333V38.1252H28.75ZM29.7917 45.4169H46.4583V43.3335H29.7917V45.4169ZM47.5 44.3752V38.1252H45.4167V44.3752H47.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.ade9c3ada338e975106226770e2904ca.svg";
export { ForwardRef as ReactComponent };